import React from "react";
import { Box, TextField, styled } from "@mui/material";

const LimitInput = styled(TextField)({
  padding: "2px 2px",
  width: 65,
  "& .MuiInputBase-input": {
    padding: "2px 2px 2px 4px",
  },
});
const Button = styled("div")({
  margin: "0 3px",
  display: "inline-flex",
  "&:hover": {
    cursor: "pointer",
  },
});

interface IProps {
  count: number;
  limit: number;
  page: number;
  setPageState: (a: number) => void;
  setLimit: (a: number) => void;
  inputProps?: {
    max: number;
    min?: number;
  };
  showFirstButton?: boolean;
  showLastButton?: boolean;
  isIgnoreCountTotalPage?: boolean;
  isHasMore?: boolean;
}

const Pagination = ({
  count,
  limit,
  setPageState,
  page,
  setLimit,
  inputProps,
  showFirstButton = true,
  showLastButton = true,
  isHasMore = true,
  isIgnoreCountTotalPage,
}: IProps): React.ReactElement => {
  const setPage = (page: number) => {
    let value = page;
    const max = Math.ceil(count / limit);
    if (value >= max && !isIgnoreCountTotalPage) value = max - 1;
    if (value <= 0) value = 0;
    setPageState(value);
  };

  const handleChangeLimit = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (inputProps && inputProps.max < +e.target.value) {
      return;
    }
    setLimit(+e.target.value);
  };

  return (
    <Box mt="5px" display="inline-flex" justifyContent="space-between" alignItems="center">
      <Box display="flex" alignItems="center">
        {showFirstButton && (
          <Button onClick={() => setPage(0)} role="button" tabIndex={-1}>
            {"|<"}
          </Button>
        )}

        <Button onClick={() => setPage(page - 1)} role="button" tabIndex={-1}>
          {"<"}
        </Button>

        <div style={{ fontWeight: "bold" }}>{page + 1}</div>
        {!isIgnoreCountTotalPage && <div>/{Math.ceil(count / limit) || 1}</div>}
        <Button onClick={() => isHasMore && setPage(page + 1)} role="button" tabIndex={-1}>
          {">"}
        </Button>
        {showLastButton && (
          <Button onClick={() => setPage(Math.ceil(count / limit) - 1)} role="button" tabIndex={-1}>
            {">|"}
          </Button>
        )}
      </Box>

      <Box display="flex" alignItems="center">
        <LimitInput
          {...inputProps}
          size="small"
          type="number"
          value={limit}
          onChange={handleChangeLimit}
        />{" "}
        <span>/page</span>
      </Box>
    </Box>
  );
};

export default Pagination;
